import { useEffect, useRef, useState, useCallback } from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { shallowEqual } from 'react-redux'

export interface FormikState<T> {
    isValid: boolean
    dirty: boolean
    values: T
}

export function useFormikStateSync<T>() {
    const formikRef = useRef<FormikProps<T>>(null)
    const [formikState, setFormikState] = useState<FormikState<T>>({
        isValid: false,
        dirty: false,
        values: {} as T,
    })

    const updateFormikState = useCallback(
        (state: FormikState<T>) => setFormikState(state),
        []
    )

    // Bridge component to be rendered inside the Formik form
    const FormikStateBridge = () => {
        const { isValid, dirty, values } = useFormikContext<T>()
        useEffect(() => {
            setFormikState((prev) => {
                if (
                    prev.isValid === isValid &&
                    prev.dirty === dirty &&
                    shallowEqual(prev.values, values)
                ) {
                    return prev
                }
                return {
                    isValid,
                    dirty,
                    values,
                }
            })
        }, [isValid, dirty, values])
        return null
    }

    return {
        formikRef,
        formikState,
        updateFormikState,
        FormikStateBridge,
    }
}
